<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.docCode"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="品类：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="供应商：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="定价类型：" :value="headInfo.priceModeDict" :options="priceModeOptions"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyDict" :options="currencyOptions"></hi-cell>
    <hi-cell title="价格类型：" :value="headInfo.priceTypeDict" :options="priceTypeOptions"></hi-cell>
    <hi-cell title="成本提供方：" :value="headInfo.costProviderDict" :options="costProviderOptions"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.docTitle"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'NewProductPricingBaseInfo',
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    priceModeOptions() {
      return this.$store.getters.dicts.mat_cost_price_dict
    },
    currencyOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    priceTypeOptions() {
      return this.$store.getters.dicts.price_type
    },
    costProviderOptions() {
      return this.$store.getters.dicts.mat_cost_provider_dict
    }
  }
}
</script>
